import { isString } from 'lodash'

export const isStringArray = (arr: unknown): arr is string[] =>
  Array.isArray(arr) && arr.length > 0 && arr.every((val) => isString(val))
